import { Icons } from '@cast/design-system';

import { PRODUCT_BASE_PATHS } from '@cast/console-constants';
import { useClustersWithApa } from 'features/apa/hooks/useClustersWithApa';

import { SidebarItem } from '../_components/SidebarItem';
import { SidebarLayout } from '../_components/SidebarLayout';
import { SidebarSection } from '../_components/SidebarSection';

export const ApaSidebar = () => {
  const basePath = PRODUCT_BASE_PATHS.apa;
  const { hasClustersWithApa } = useClustersWithApa();

  return (
    <SidebarLayout
      title="APA"
      subtitle="Agentic runbooks"
      icon={<Icons.CastApa variant="preset" weight="light" size={24} />}
    >
      <SidebarSection>
        <SidebarItem
          title="Runbooks"
          url={`${basePath}/runbooks`}
          allowedInReadOnlyOrg
        />

        <SidebarItem
          title="Integrations"
          url={`${basePath}/integrations`}
          rules={[['view', 'OrganizationApaRunbooks']]}
        />

        {hasClustersWithApa && (
          <SidebarItem
            title="Settings"
            url={`${basePath}/settings`}
            rules={[['view', 'OrganizationApaRunbooks']]}
          />
        )}
      </SidebarSection>
    </SidebarLayout>
  );
};
